import React, { Fragment } from 'react';
import * as utilities from "../../utilities/utils";
import moment from "moment";
import history from "../../utilities/history";
import handSvg from "../../images/hand.svg";

import { CLAIMTYPE, CLAIMTYPE_FR } from '../../App.config';
import Pdf from "../../images/pdf.png";
import Excel from "../../images/excel.png";

const AirCaseDetailTableComponent = (props) => {
    return (
        <>
            {Array.isArray(props.applicants) && props.applicants.filter(x => x.isAIR).length
                ?
                <>
                    {/* {!props.isRedirectCurrentActivityScreen &&
                        <div className="applicant-view-tab">
                            <button className="downloadall" onClick={() => { props.onAllCaseDownload(true, props.einParam, false) }}>{props.context.t("Attachment.DownloadAll.Text")} <span><img src={Excel} alt="" /></span></button>
                            <button className="downloadall" onClick={() => { props.onAllCaseDownload(true, props.einParam, true) }}>{props.context.t("Attachment.DownloadAll.Text")} <span><img src={Pdf} alt="" /></span></button>
                        </div>} */}
                    {/* <div class="applicant-view-tab">
                        <button onClick={() => {props.onAllCaseDownload(true,props.einParam,false)}}>Download All Excel</button>
                        <button onClick={() => {props.onAllCaseDownload(true,props.einParam,true)}}>Download All PDF</button>
                    </div> */}
                    <table className="table ">
                        <thead>
                            <tr>
                                <th>{props.context.t("CurrentActivity.Name.Text")}</th>
                                <th>{props.context.t("CurrentActivity.airDate.Text")}</th>
                                <th>{props.context.t("CurrentActivity.nextAction.Text")}</th>
                                <th>{props.context.t("CurrentActivity.followUpDate.Text")}</th>
                                {/* {!props.isRedirectCurrentActivityScreen && <th>Action</th>} */}
                            </tr>
                        </thead>
                        <tbody>
                            {props.applicants.map((caseDetail, index) => {
                                return (
                                    caseDetail.isAIR ?
                                        <Fragment key={`${index}`}>
                                            <tr
                                                className="case-status-tb-row bg-blue text-white"

                                            >

                                                <td onClick={() => props.addRow(index)}>
                                                    {caseDetail.firstName} {caseDetail.lastName}
                                                </td>
                                                <td onClick={() => props.addRow(index)}>
                                                    {caseDetail.dateAIRSubmitted
                                                        ? utilities.formatDate(
                                                            caseDetail.dateAIRSubmitted,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                                <td onClick={() => props.addRow(index)}>
                                                    {caseDetail.nextAction ? caseDetail.nextAction : "-"}
                                                </td>
                                                <td onClick={() => props.addRow(index)}>
                                                    {caseDetail.followUpDate
                                                        ? utilities.formatDate(
                                                            caseDetail.followUpDate,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                                {/* {!props.isRedirectCurrentActivityScreen && <td>
                                                    <span onClick={() => { props.onCaseDownload(true, caseDetail.caseMgmtID, props.einParam, true) }}><img src={Pdf} alt="" /></span>
                                                    <span onClick={() => { props.onCaseDownload(true, caseDetail.caseMgmtID, props.einParam, false) }}><img src={Excel} alt="" /></span>
                                                </td>} */}
                                            </tr>

                                            {

                                                (caseDetail.otherData && caseDetail.otherData.isAIR) ? (
                                                    <>
                                                        <tr>
                                                            <td>{props.context.t("AIR-Employer-Information.form.label.text.Location")}</td>
                                                            <td>
                                                                {caseDetail.otherData.location ? caseDetail.otherData.location : "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                                            <td>{caseDetail.otherData.managedBy ? caseDetail.otherData.managedBy : "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.DateAirSubmitted.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.dateAIRSubmitted ? moment(caseDetail.otherData.dateAIRSubmitted).format("MMM DD YYYY") : "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.OpenOrClosed.Text")}</td>
                                                            <td>
                                                                {
                                                                    (props.selectedLanguage == "en-US") ?
                                                                        (caseDetail.otherData.isAIRCaseOpen ? "Open" : "Closed")
                                                                        :
                                                                        (caseDetail.otherData.isAIRCaseOpen ? "Ouvert" : "Fermé")
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.ClaimType.Text")}</td>
                                                            <td>
                                                                {
                                                                    (props.selectedLanguage == "en-US") ? CLAIMTYPE[caseDetail.otherData.claimTypeAIR] : CLAIMTYPE_FR[caseDetail.otherData.claimTypeAIR]}
                                                                {/* {caseDetail.otherData.claimTypeAIR ? caseDetail.otherData.claimTypeAIR : "-"} */}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.DateOfIncident.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.dateOfIncident ? moment(caseDetail.otherData.dateOfIncident).format("MMM DD YYYY") : "-"}

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.DateOfLostBegan.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.dateLostTimeBegan ? moment(caseDetail.otherData.dateLostTimeBegan).format("MMM DD YYYY") : "-"}

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.EmployeeReturnToWork.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.dateEmployeeReturnedToWork ? moment(caseDetail.otherData.dateEmployeeReturnedToWork).format("MMM DD YYYY") : "-"}


                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.ReturnToWorkStatus.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.rtwAIRStatus ? caseDetail.otherData.rtwAIRStatus : "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.FileStatus.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.airFileStatus ? caseDetail.otherData.airFileStatus : "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.ClaimStatus.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.claimStatus ? caseDetail.otherData.claimStatus : "-"}

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{props.context.t("AIR.NextActionAndFollowUpDate.Text")}</td>
                                                            <td>
                                                                {caseDetail.otherData.airNextAction ? caseDetail.otherData.airNextAction : "-"}
                                                                {" "}
                                                                {caseDetail.otherData.followUpDate ? moment(caseDetail.otherData.followUpDate).format("MMM DD YYYY") : "-"}

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            {/* //status.hrs */}
                                                            <td>{props.context.t("AIR.ModifiedHours.Text")}</td>
                                                            <td>
                                                                {caseDetail.modifiedHours ? caseDetail.modifiedHours : "-"}
                                                                {/* {"-"} */}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Notes</td>
                                                            <td>
                                                            {caseDetail.notes ? caseDetail.notes : "-"}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : null
                                            }

                                        </Fragment>
                                        : null
                                )
                            })
                            }

                        </tbody>
                    </table>
                </>

                : null
            }
        </>
    )
}

export default AirCaseDetailTableComponent;